
<script type="text/javascript">
	import { onMount } from "svelte";
	export let materialIcon = ""
	export let spacer = false;
	export let link = false;
	let element;

	// TODO: It might be nice to automatically add the "link" class when there is an on:click event. But I haven't figured out how to do this!
	onMount(()=>{
		// console.log(element);
		// console.log(element.onclick);
		// if (element.onclick) {
		// 	element.addClass("link");
		// }
	});
</script>

<style type="text/scss">
	h1 {
		display:inline-block;
	}
	h1.link {
		cursor:pointer;
		color: var(--mdc-theme-primary, #666);
		text-decoration:none;
	}
	h1.link:hover {
		text-decoration:underline;
	}
	h1.spacer {
		margin-left:5px;
		margin-right:5px;
		font-size:16px;
		color:#999;
	}
</style>

<h1 bind:this={element} on:click class:link={link} class:spacer={spacer}>
	{#if spacer}
		&gt;
	{:else}
		{#if materialIcon != null}
			<span class='material-icons header-icon'>{materialIcon}</span>
		{/if}
		<slot/>
	{/if}
</h1>
